import { colors } from '@mui/material';
import {
  PVBlack,
  PVNavy,
  PVGray,
  PVGreen,
  PVGreenDark,
  PVIvory,
  PVRed,
  PVYellow,
  PVPurple,
  PVOrange,
  PVPink,
  PVLightGray,
  PVDarkRed,
  PVHoverNavy,
  PVHoverNavyDark,
  PVPremiumPurple,
} from '../../../colors';

const white = '#FFFFFF';

export default {
  black: PVBlack,
  white,
  PVRed,
  PVNavy,
  PVGray,
  PVGreen,
  primary: {
    contrastText: white,
    main: PVNavy,
    yellow: PVYellow,
    purple: PVPurple,
    hoverNavy: PVHoverNavy,
    hoverNavyDark: PVHoverNavyDark,
    orange: PVOrange,
    pink: PVPink,
    gray: PVGray,
    darkRed: PVDarkRed,
    lightGray: PVLightGray,
    premium: PVPremiumPurple,
  },
  secondary: {
    contrastText: white,
    main: PVRed,
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: PVRed,
    light: colors.red[400],
  },
  success: {
    contrastText: white,
    main: PVGreenDark,
    light: PVGreen,
  },
  warning: {
    contrastText: white,
    main: '#FFA726',
  },
  text: {
    primary: PVBlack,
    secondary: '#666666',
    tertiary: '#5F5F61B2',
    link: PVRed,
    inverted: PVIvory,
  },
  link: PVRed,
  icon: PVGray,
  background: {
    default: PVIvory,
    paper: white,
  },
  divider: colors.grey[200],
  info: {
    main: white,
    contrastText: PVNavy,
    dark: PVHoverNavy,
  },
  action: {
    hover: PVHoverNavy,
    focus: PVHoverNavyDark,
    selected: PVHoverNavyDark,
  },
};
